<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
    :type="show ? 'text' : 'password'"
    autocomplete="one-time-code"
    @click:append="show = !show"
  ></v-text-field>
</template>

<script>
export default {
  data() {
    return { show: false }
  },
}
</script>
